export default {
  "content": "<path d=\"M19.766 9.51A10.764 10.764 0 0010 3.75 10.764 10.764 0 00.234 9.51a1.041 1.041 0 000 .978A10.765 10.765 0 0010 16.25a10.764 10.764 0 009.766-5.762 1.041 1.041 0 000-.977zM10 15a5 5 0 110-10 5 5 0 010 10z\" fill=\"#C9CBD4\"/><path d=\"M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z\" fill=\"#C9CBD4\"/>",
  "attrs": {
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};